import { Link } from '@tanstack/react-router'

import { WhatsAppSendingSwitch } from '@/components/WhatsAppSendingSwitch'

/**
 * WhatsApp configuration tab — the master sending switch, kept here where
 * staff expect it. The switch also appears on the admin Settings page, which
 * is where the message templates and the rest of the WhatsApp configuration
 * now live.
 */
export function WhatsAppSettingsTab() {
  return (
    <div className="space-y-6">
      <WhatsAppSendingSwitch />
      <p className="text-[13px] text-slate-500">
        Message templates, the Twilio connection and the send delay are managed
        by admins on the{' '}
        <Link to="/settings" className="font-medium text-blue-700 hover:underline">
          Settings
        </Link>{' '}
        page.
      </p>
    </div>
  )
}
